<template>
    <header>
        <base-nav transparent effect="black" expand type="default" style="background-color: #333 !important;">
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="https://anthromindxx.com/ant/LOGO.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="#/">
                        <img src="https://anthromindxx.com/ant/LOGO.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#/" id="navbar-primary_dropdown_1" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="ni ni-collection d-lg-none"></i>
                        首页</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#/DocQuery" id="navbar-primary_dropdown_1" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="ni ni-collection d-lg-none"></i>
                        文献查询</a>
                </li>

                <!-- <li class="nav-item dropdown">
                    <a class="nav-link" href="https://anthromindxx.com/blog/" id="navbar-primary_dropdown_1" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" target="_blank">
                    <i class="ni ni-collection d-lg-none"></i>
                    个人博客</a>
                </li> -->

                <li class="nav-item dropdown">
                    <a class="nav-link" href="#/PersBlog" id="navbar-primary_dropdown_1" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="ni ni-collection d-lg-none"></i>
                        个人博客</a>
                </li>

<li class="nav-item dropdown">
                    <a class="nav-link" href="#/DocQueryList?searchQuery=%2Flatest" id="navbar-primary_dropdown_1" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="ni ni-collection d-lg-none"></i>
                        每日更新</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#/AboutUs" id="navbar-primary_dropdown_1" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="ni ni-collection d-lg-none"></i>
                        关于我们</a>
                </li>

            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <!-- 如果已登录，显示下拉菜单 -->
                <base-dropdown v-if="username" tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ 'hi, ' + username }}</span>
                    </a>
                    <base-button @click="personalData" class="dropdown-item">个人资料</base-button>
                    <base-button @click="personalCollect" class="dropdown-item">我的收藏</base-button>
                    <base-button @click="logout" class="dropdown-item">退出登录</base-button>
                </base-dropdown>

                <!-- 如果未登录，显示“请登录”提示并跳转到登录页面 -->
                <li v-else class="nav-item">
                    <a href="#" class="nav-link" @click.prevent="$router.push('/login')">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">请登录</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
    components: {
        BaseNav,
        CloseButton,
        BaseDropdown
    }, 
	created() {
        this.username = this.getCookie('username');
    },
    methods: {
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        clearCookie(name) {
            // 清除 cookie 时确保设置过期时间和路径
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        },
        personalData() { //个人资料
            this.$router.push('/PersonalDataList?searchQuery=2');
        },
        personalCollect() { //个人收藏
            // this.$router.push('/landing');
           // this.$router.push('/PersonalCollectList?searchQuery=');
        },
        logout() {
            // 清除 token 和 username 的 cookie
            this.clearCookie('token');
            this.clearCookie('username');
            // 清除本地存储的用户名，确保界面更新
            this.username = '';  // 清空保存的用户名
            this.$router.push('/');  // 跳转到主页
            window.location.reload();
        }
    },
    data() {
        return {
            username: '',  // 保存用户名
        };
    }
};
</script>
<style scoped>
.navbar-main {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.navbar-brand {
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: center;
}

ul.navbar-nav {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
}


.nav-item {
    padding: 0 10px; /* 减少导航项之间的间距 */
    white-space: nowrap; /* 防止导航项文字换行 */
}
</style>